import { save } from '@cogitate/ui-multi-utils';
import { commonKeys, requestKeys } from 'ui/data/constants/keys';
import { toast } from 'react-toastify';
import NProgress from 'nprogress';

const proceedToCheckoutSubmit = async (summary) => {
  try {
    NProgress.start();
    const resp = await save(summary, commonKeys.EmptyString, requestKeys.ProceedToCheckout, commonKeys.EmptyString);
    return resp;
  } catch (error) {
    toast.error(error);
    return;
  }
};

export { proceedToCheckoutSubmit };
